<div class="modal-header">
  <h4 class="modal-title pull-left">{{modalHeaderText}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label class="form-label">Tenant Name<span class="star">*</span></label>
    <input class="form-control" #name="ngModel" maxlength="100" [(ngModel)]="tenant.Name" required type="text">
    <p class="redtext" *ngIf="(Validation.IsinValid(tenant.Name) && isSubmit) ||(name.invalid && name.touched)">Tenant Name is required </p>
  </div>
  <div class="form-group">
    <label class="form-label">URL</label>
    <input class="form-control" #URL="ngModel" maxlength="500" [(ngModel)]="tenant.URL" type="text">
    <p class="redtext" *ngIf="!Validation.IsinValid(tenant.URL) && !URLValid && isSubmit">Website is not valid</p>
  </div>
  <div class="form-group">
    <label class="form-label">Property Type</label>
    <div class="select-dropdown multiselectdesign select-check">
       <mat-form-field   >
        <mat-select [(ngModel)]="tenant.TypeId"
                    placeholder="Select"
                   [multiple]="true"
                   (selectionChange)="getSubcategoryList($event.value)"
                   #PropertyType (click)="addClassToOverlayContainer();">
           @if (tenant?.TypeId?.length > 1) {
              <mat-select-trigger (click)="$event.stopPropagation()">
                <span>{{ tenant?.TypeId?.length }} items selected</span>
              </mat-select-trigger>
            }

          <mat-option *ngFor="let type of propertyTypeList" class="multi-dropdown-item" [value]="type.id">
            {{type.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="form-label">Subcategory</label>
    <div id="divSubcategory" class="select-dropdown multiselectdesign select-check">
       <mat-form-field   >
        <mat-select [(ngModel)]="tenant.SubcategoryId"
                   (selectionChange)="changeCurrentSelection()"
                   #Subcategory multiple (click)="addClassToOverlayContainer();">
           @if (tenant?.SubcategoryId?.length > 1) {
              <mat-select-trigger>
                <span>{{ tenant?.SubcategoryId?.length }} items selected</span>
              </mat-select-trigger>
            }   
            <mat-option>
              <ngx-mat-select-search 
                #searchKey 
                [hideClearSearchButton]="true"
                [disableInitialFocus]="true"
                placeholderLabel="Search by Subcategory" 
                noEntriesFoundLabel="Nothing found..."
                [enableClearOnEscapePressed]="true">
            </ngx-mat-select-search>
            </mat-option>
                  
          <mat-option *ngFor="let subcategory of subcategoryList | arraySearch : 'name' : searchKey.value" class="multi-dropdown-item" [value]="subcategory.id">
            {{subcategory.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="form-label">Ticker Symbol</label>
    <input class="form-control" #TickerSymbol="ngModel" maxlength="50" [(ngModel)]="tenant.TickerSymbol" required type="text">
  </div>
  <!--<div class="form-group" *ngIf="modalHeaderText=='Add Tenant'">
    <label class="custom-checkbox" for="chkPortfolioSaleOnly">
      <input type="checkbox" [(ngModel)]="tenant.CreateGuarantor" id="chkPortfolioSaleOnly">
      Create Guarantor
      <i></i>
    </label>
  </div>-->
  <div class="form-group" *ngIf="modalHeaderText=='Add Tenant'&&tenant.CreateGuarantor">
    <label class="form-label">
      Guarantor Name<span class="star">*</span>
      <label class="custom-checkbox" style="float:right; height:10px; cursor:pointer" for="chkPortfolioSaleOnly">
        <input type="checkbox" [(ngModel)]="tenant.CreateGuarantor" id="chkPortfolioSaleOnly">
        New Guarantor
        <i></i>
      </label>
    </label>
    <input class="form-control" #GuarantorName="ngModel" maxlength="100" [(ngModel)]="tenant.GuarantorName" required type="text">
    <p class="redtext" *ngIf="(Validation.IsinValid(tenant.GuarantorName) && isSubmit) ||(GuarantorName.invalid && GuarantorName.touched)">Guarantor Name is required </p>
  </div>
  <div class="margin-top-30  tool-top-box tool-top-box1" *ngIf="modalHeaderText!='Add Tenant'&&gurantorCount>0">
    <label>Guarantors</label>
    <h6 class="countstyle tenantCount" tooltip="{{guarnatorList}}">{{gurantorCount}}</h6>
  </div>
  <div class="form-group" *ngIf="modalHeaderText=='Add Tenant'&&tenant.CreateGuarantor">
    <label class="form-label">S&amp;P Rating</label>
    <label class="select">
      <select [(ngModel)]="tenant.SPRatingId" class="form-control ">
        <option [value]="0">Select</option>
        <option *ngFor="let item of sprRatingList" [(ngValue)]="item.id">{{item.description}}</option>
      </select>
      <i></i>
    </label>
  </div>
  <div class="form-group" *ngIf="modalHeaderText=='Add Tenant'&&tenant.CreateGuarantor">
    <label class="form-label">Moody's Rating</label>
    <label class="select">
      <select [(ngModel)]="tenant.MoodyRatingId"
              class="form-control ">
        <option [value]="0">Select</option>
        <option *ngFor="let item of moodysRatingList" [(ngValue)]="item.id">{{item.description}}</option>
      </select>
      <i></i>
    </label>
  </div>
  <div class="form-group" *ngIf="modalHeaderText=='Add Tenant'&&tenant.CreateGuarantor">
    <label class="form-label">Fitch Rating</label>
    <label class="select">
      <select [(ngModel)]="tenant.FitchRatingId"
              class="form-control">
        <option [value]="0">Select</option>
        <option *ngFor="let item of fitchRatingList" [(ngValue)]="item.id">{{item.description}}</option>
      </select>
      <i></i>
    </label>
  </div>
  <!--<div class="form-group" *ngIf="modalHeaderText=='Add Tenant'&&!tenant.CreateGuarantor">
    <label class="form-label">Guarantor</label>
    <div id="divSubcategory" class="select-dropdown be-multiselectdesign  multiselectdesign select-check">
      <ng-multiselect-dropdown class="ng-multiselect-dropdown" [placeholder]="'Select Guarantor'"
                               [data]="guarantorList"
                               [(ngModel)]="tenant.GuarantorId"
                               [settings]="dropdownSettings"
                               (onSelect)="onItemGuarantorSelect($event)"
                               (onDeSelect)="onItemGuarantorDeSelect($event)">
      </ng-multiselect-dropdown>
    </div>
  </div>-->
  <div class="form-group" *ngIf="modalHeaderText=='Add Tenant'&&!tenant.CreateGuarantor">
    <label class="form-label">
      Guarantor
      <label class="custom-checkbox" style="float:right; height:10px; cursor:pointer" for="chkPortfolioSaleOnly">
        <input type="checkbox" [(ngModel)]="tenant.CreateGuarantor" id="chkPortfolioSaleOnly">
        New Guarantor
        <i></i>
      </label>
    </label>
    <div id="divSubcategory" class="select-dropdown multiselectdesign select-check">
      <mat-form-field>
        <mat-select 
          [(ngModel)]="tenant.GuarantorId" 
          name="guarantor" 
          (selectionChange)="onItemGuarantorSelect()" 
          (openedChange)="$event && loadGuarantorData($event)"
          #Subcategory 
          multiple
          (click)="addClassToOverlayContainer();">
          <mat-select-trigger *ngIf="tenant?.GuarantorId?.length > 1">
            <span>{{ tenant?.GuarantorId?.length }} items selected</span>
          </mat-select-trigger>
          
          <mat-option>
            <ngx-mat-select-search 
              #searchKey 
              [hideClearSearchButton]="true"
              [disableInitialFocus]="true"
              placeholderLabel="Search here" 
              noEntriesFoundLabel="Nothing found..."
              [clearSearchInput]="true"
              [enableClearOnEscapePressed]="true">
            </ngx-mat-select-search>
          </mat-option>
      
          <!-- Loop through guarantor list -->
          <mat-option 
            *ngFor="let guarantor of guarantorList | arraySearch : 'name' : searchKey.value" 
            [value]="guarantor.id" class="multi-dropdown-item">
            {{ guarantor.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
    <div class="text-right">
      <button class="btn btn-default btn-lg" id="closeModal" (click)="hideModal();">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="saveTenantModal(templateConfirm,'deletemodal');">Save</button>
    </div>
  </div>

<ng-template #templateConfirm>

  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefConfirmation.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you’d like to Add new Tenant without a Guarantor?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefConfirmation.hide();">No</button>
      <button class="btn btn-lg btn-success" (click)="modalRefConfirmation.hide();saveTenant();">Yes</button>
    </div>
  </div>
</ng-template>
